export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const USER_EMAIL_MAX_LENGTH = 128;
export const USER_FIRST_NAME_MAX_LENGTH = 32;
export const USER_LAST_NAME_MAX_LENGTH = 32;
export const PASSWORD_LOWERCASE_PATTERN = /[a-z]/;
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_NUMBER_PATTERN = /[0-9]/;
export const PASSWORD_REPEATED_CHARACTER_PATTERN = /(.)\1{2,}/;
export const PASSWORD_SPECIAL_CHARACTER_PATTERN = /[!@#%^&*]/;
export const PASSWORD_UPPERCASE_PATTERN = /[A-Z]/;

/**
 * Staff sign in through Auth0, which collects the password on its own form —
 * this service never sees one. An address in this domain therefore needs no
 * password field here.
 *
 * This is presentation, not a security control: it is client-side and trivially
 * bypassed. What actually decides who can sign in is which connections are
 * enabled on the Auth0 application, which today is the Infillion directory and
 * nothing else.
 */
export const STAFF_EMAIL_DOMAIN = "@infillion.com";

export const isStaffEmail = (email: string): boolean =>
  email.trim().toLowerCase().endsWith(STAFF_EMAIL_DOMAIN);

/**
 * The identifier Auth0's form expects, which is the address as typed.
 *
 * Staff sign in through OktaInfillion, a SAML connection, and Okta identifies
 * users by their full email address.
 *
 * This deliberately does not strip the domain. An earlier version did, because
 * the application was pointed at InfillionActiveDirectory — an AD/LDAP
 * connector fronting real Active Directory, which matches on sAMAccountName.
 * That was the wrong connection: nobody signs in through it, and 63 other
 * applications on the tenant use Okta instead. Trimming the domain for a SAML
 * provider would break what it was written to fix.
 */
export const toLoginHint = (email: string): string => email.trim();
